"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי לבית המטופל?",
  answer: "אנו מתחייבים למציאת פתרון והגעת מטפל מקצועי תוך 5 שעות בלבד מרגע הפנייה. המערך הלוגיסטי שלנו פרוס בכל הארץ כדי להבטיח מענה מיידי במצבי חירום או צורך דחוף."
}, {
  question: "האם המטפלים שלכם עוברים הכשרה מקצועית?",
  answer: "בהחלט. כל המטפלים בצוות שלנו עוברים סינון קפדני, בדיקת המלצות והכשרות תקופתיות בתחומי העזרה הראשונה, הטיפול הסיעודי והתמיכה הרגשית לקשישים."
}, {
  question: "מה כולל השירות של מטפל סיעודי פרטי?",
  answer: "השירות מותאם אישית וכולל סיוע ברחצה, הלבשה, האכלה, ליווי לבדיקות רפואיות, השגחה בלילה, ניהול תרופות ומתן חברה ותמיכה רגשית למטופל בביתו."
}, {
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: "כן, המוקד שלנו פעיל 24/7 ואנו מספקים שירותי סיעוד והשגחה בכל ימות השנה, כולל שבתות וחגים, כדי להבטיח שקט נפשי מלא למשפחה."
}, {
  question: "איך מתבצע תהליך ההתאמה בין המטפל למטופל?",
  answer: "אנו שמים דגש על התאמה אישיותית ומקצועית. אנו בוחנים את הצרכים הרפואיים של המטופל, השפה המדוברת והעדפות אישיות כדי ליצור חיבור אנושי מיטבי."
}, {
  question: "האם ישנה התחייבות לתקופה ארוכה?",
  answer: "לא, אנו מאמינים בגמישות מלאה. ניתן להזמין שירות לטווח קצר (כמו לאחר ניתוח) או לטווח ארוך, בהתאם לצורך המשתנה שלכם."
}, {
  question: "האם אתם מסייעים בהגשת תביעות לביטוח הלאומי?",
  answer: "הצוות המקצועי שלנו מעניק ייעוץ ראשוני והכוונה לגבי מיצוי זכויות מול המוסד לביטוח לאומי וחברות הביטוח הפרטיות כדי להקל עליכם את התהליך הבירוקרטי."
}];
export default function FaqAccordionCoachingValue() {
  return <section data-section-id="252312" id="שאלות-נפוצות" className="w-full flex flex-col bg-background text-foreground">
      {}
      <div className="bg-primary w-full py-20 md:py-32 flex items-center justify-center">
        <div className="bg-secondary px-8 py-4 md:px-12 md:py-6 rounded-lg shadow-lg">
          <h2 className="text-secondary-foreground text-5xl md:text-7xl font-default font-bold tracking-wide">
            שאלות ותשובות
          </h2>
        </div>
      </div>

      {}
      <div className="w-full bg-gradient-to-b from-background to-accent py-20 md:py-32 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-10">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-none bg-card p-6 rounded-lg shadow-md">
                <AccordionTrigger className="text-primary hover:text-secondary-foreground font-default font-semibold text-xl md:text-2xl text-right hover:no-underline py-0 [&>svg]:text-primary [&>svg]:size-6 transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pt-6 pb-4 font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}